import {EVENT_STATUS, QUOTE_STATUS,ENUM_EVENT_STATUS,ENUM_QUOTE_STATUS,ROUTE_AFFILIATE_EVENTS, ROUTE_AFFILIATE_QUOTES, SHIFT_STATUS,ENUM_SHIFT_STATUS} from '../../configs/staticConfigs';

export  const showPreviewQuoteBtn = (isClient,eventStatusId,quoteStatusId,quoteNumber,shiftCount) =>{ 
    if(isClient && ( Number(eventStatusId)===Number(EVENT_STATUS[ENUM_EVENT_STATUS.ESTIMATION].statusCode) || Number(eventStatusId)===Number(EVENT_STATUS[ENUM_EVENT_STATUS.QUOTE_REQUESTED].statusCode) )){
        return false;
    }else if(quoteNumber===null || shiftCount===0 ){
        return false;
    }
    return true; 
}

export  const showRequestQuoteBtn = (isClient,eventStatusId,quoteStatusId) =>{
    if(isClient && 
        (Number(quoteStatusId)===Number(QUOTE_STATUS[ENUM_QUOTE_STATUS.ESTIMATION].statusCode) ||  
        Number(quoteStatusId)===Number(QUOTE_STATUS[ENUM_QUOTE_STATUS.REESTIMATION].statusCode)) 
        && (Number(eventStatusId)!==Number(EVENT_STATUS[ENUM_EVENT_STATUS.CANCELLED].statusCode)) 
        && (Number(eventStatusId)!==Number(EVENT_STATUS[ENUM_EVENT_STATUS.COMPLETED].statusCode)) 
        && (Number(eventStatusId)!==Number(EVENT_STATUS[ENUM_EVENT_STATUS.INVOICED].statusCode))
    ){
        return true;
    }
    return false;
}

export const showSendQuoteBtn = (isClient,quoteStatusId,quoteNumber,shiftCount,eventStatusId) =>{ 
    if(!isClient && shiftCount>0 && 
        (Number(quoteStatusId)===Number(QUOTE_STATUS[ENUM_QUOTE_STATUS.ESTIMATION].statusCode) || Number(quoteStatusId)===Number(QUOTE_STATUS[ENUM_QUOTE_STATUS.QUOTE_REQUESTED].statusCode) || Number(quoteStatusId)===Number(QUOTE_STATUS[ENUM_QUOTE_STATUS.REESTIMATION].statusCode)) && 
        (Number(eventStatusId)!==Number(EVENT_STATUS[ENUM_EVENT_STATUS.COMPLETED].statusCode)) && 
        (Number(eventStatusId)!==Number(EVENT_STATUS[ENUM_EVENT_STATUS.INVOICED].statusCode)) && 
        (quoteNumber!==null) ){
        return true;
    }
    return false; 
}

// FOR AFFILIATES ONLY, QUOTE CAN BE ACCEPTED IN STATUS - QUOTE_SENT, ESTIMATION & REESTIMATION - 30SEP2020
export const showAcceptRejectQuoteBtnAflt = (isClient,eventStatusId,quoteStatusId) =>{ 
    if(isClient && (Number(quoteStatusId)===Number(QUOTE_STATUS[ENUM_QUOTE_STATUS.QUOTE_SENT].statusCode) || Number(quoteStatusId)===Number(QUOTE_STATUS[ENUM_QUOTE_STATUS.ESTIMATION].statusCode) || Number(quoteStatusId)===Number(QUOTE_STATUS[ENUM_QUOTE_STATUS.REESTIMATION].statusCode) || Number(quoteStatusId)===Number(QUOTE_STATUS[ENUM_QUOTE_STATUS.QUOTE_REQUESTED].statusCode)) ){
        return true;
    }
    return false;
}

export const showAcceptRejectQuoteBtn = (isClient,eventStatusId,quoteStatusId) =>{ 
    if(isClient && (Number(quoteStatusId)===Number(QUOTE_STATUS[ENUM_QUOTE_STATUS.QUOTE_SENT].statusCode)) ){
        return true;
    }
    return false;
}

export const showDownloadQuoteBtn = (isClient,statusId,quoteNumber,shiftCount) =>{ 
    if( isClient && (  (statusId===Number(EVENT_STATUS[ENUM_EVENT_STATUS.ESTIMATION].statusCode)) || (Number(statusId)===Number(EVENT_STATUS[ENUM_EVENT_STATUS.QUOTE_REQUESTED].statusCode)) || (Number(statusId)===Number(EVENT_STATUS[ENUM_EVENT_STATUS.REESTIMATION].statusCode) ) )){
        return false;
    }else if(quoteNumber===null || shiftCount===0){
        return false;
    }
    return true;    
}

export const showScheduleBtn = (isClient,shiftCount,eventStatusId) =>{ 
    if(!isClient && shiftCount>0 && 
        eventStatusId!==Number(EVENT_STATUS[ENUM_EVENT_STATUS.COMPLETED].statusCode) && 
        eventStatusId!==Number(EVENT_STATUS[ENUM_EVENT_STATUS.INVOICED].statusCode)
    ){
        return true;
    }
    return false;
}

export const eventRouteRedirect = (eventStatusId) =>{
    if(eventStatusId===Number(EVENT_STATUS[ENUM_EVENT_STATUS.ESTIMATION].statusCode) || eventStatusId===Number(EVENT_STATUS[ENUM_EVENT_STATUS.REESTIMATION].statusCode) || eventStatusId===Number(EVENT_STATUS[ENUM_EVENT_STATUS.QUOTE_REQUESTED].statusCode) || eventStatusId===Number(EVENT_STATUS[ENUM_EVENT_STATUS.QUOTE_SENT].statusCode) || eventStatusId===Number(EVENT_STATUS[ENUM_EVENT_STATUS.DECLINED].statusCode) ){
        return ROUTE_AFFILIATE_QUOTES;
    }else{
        return ROUTE_AFFILIATE_EVENTS;
    }
}

export const showShiftDeleteBtn = (shiftStatusId) =>{ 
    if(shiftStatusId===Number(SHIFT_STATUS[ENUM_SHIFT_STATUS.ESTIMATION].statusCode) || shiftStatusId===Number(SHIFT_STATUS[ENUM_SHIFT_STATUS.QUOTE_REQUESTED].statusCode) || shiftStatusId===Number(SHIFT_STATUS[ENUM_SHIFT_STATUS.QUOTE_SENT].statusCode) || shiftStatusId===Number(SHIFT_STATUS[ENUM_SHIFT_STATUS.DECLINED].statusCode) || shiftStatusId===Number(SHIFT_STATUS[ENUM_SHIFT_STATUS.REESTIMATION].statusCode) ){
        return true;
    }
    return false;
}

export const showEventDeleteBtn = (isClient,eventStatusId) =>{ 
    if( !isClient &&(eventStatusId===Number(EVENT_STATUS[ENUM_EVENT_STATUS.ESTIMATION].statusCode) || eventStatusId===Number(EVENT_STATUS[ENUM_EVENT_STATUS.QUOTE_REQUESTED].statusCode) || eventStatusId===Number(EVENT_STATUS[ENUM_EVENT_STATUS.QUOTE_SENT].statusCode) || eventStatusId===Number(EVENT_STATUS[ENUM_EVENT_STATUS.DECLINED].statusCode) || eventStatusId===Number(EVENT_STATUS[ENUM_EVENT_STATUS.REESTIMATION].statusCode) )){
        return true;
    }
    return false;
}

export const showSendInvoiceBtn = (isClient,eventStatusId) => { 
    if(!isClient && eventStatusId===Number(EVENT_STATUS[ENUM_EVENT_STATUS.INVOICED].statusCode)) {
        return true;
    }
    // NEW INVOICE STATUS 'INVOICED' CREATED IN MARCH 2025 AS PER CLIENT REQUEST - 
    // TO CHECK WJHETHER INVOICE SENT TO CLIENT - VALIDATE API RESPONSE FIELD bot_sent_invoice AS true
    // eventStatusId===Number(EVENT_STATUS[ENUM_EVENT_STATUS.COMPLETED].statusCode) ||
    // eventStatusId===Number(EVENT_STATUS[ENUM_EVENT_STATUS.ON_GOING].statusCode) || 
    // ONGOING STATUS REMOVED FROM THIS FUNCTION ON 09JULY2021 AFTER CONFIRM WITH JAYESH & HARISH 
    return false;
} 

export const showClientEventDeleteBtn = (isClient,eventStatusId,createdBy) =>{ 
    if(isClient && (eventStatusId===Number(EVENT_STATUS[ENUM_EVENT_STATUS.ESTIMATION].statusCode)) && createdBy==='client' ){
        return true;
    }
    return false;
}

export const showEventCancelBtn = (isClient,eventStatusId) =>{ 
    if(!isClient && eventStatusId!==Number(EVENT_STATUS[ENUM_EVENT_STATUS.DECLINED].statusCode) && 
        eventStatusId!==Number(EVENT_STATUS[ENUM_EVENT_STATUS.CANCELLED].statusCode) && 
        eventStatusId!==Number(EVENT_STATUS[ENUM_EVENT_STATUS.COMPLETED].statusCode) && 
        eventStatusId!==Number(EVENT_STATUS[ENUM_EVENT_STATUS.INVOICED].statusCode) ){
        return true;
    }
    return false;
}

export const checkEventNotCancelled = (eventStatusId) =>{ 
    if(eventStatusId!==Number(EVENT_STATUS[ENUM_EVENT_STATUS.CANCELLED].statusCode)){
        return true;
    }
    return false;
}

export const checkShiftNotCancelled = (shiftStatusId) =>{ 
    if(shiftStatusId!==Number(SHIFT_STATUS[ENUM_SHIFT_STATUS.CANCELLED].statusCode)){
        return true;
    }
    return false;
}

export const shiftEditDisable = (shiftStatusId) =>{ 
    // shiftStatusId===Number(SHIFT_STATUS[ENUM_SHIFT_STATUS.ON_GOING].statusCode) || 
    // shiftStatusId===Number(SHIFT_STATUS[ENUM_SHIFT_STATUS.COMPLETED].statusCode) || 
    if(shiftStatusId===Number(SHIFT_STATUS[ENUM_SHIFT_STATUS.CANCELLED].statusCode)
    ) {
        return true;
    }
    return false;
}

export const showAddCrewBtn = (shiftStatusId) =>{ 
    if(shiftStatusId===Number(SHIFT_STATUS[ENUM_SHIFT_STATUS.ON_GOING].statusCode) || shiftStatusId===Number(SHIFT_STATUS[ENUM_SHIFT_STATUS.CONFIRMED].statusCode)){
        return true;
    }
    return false;
}

// export const showShiftEditBtn = (shiftStatusId) =>{ 
//     if(shiftStatusId!==Number(SHIFT_STATUS[ENUM_SHIFT_STATUS.COMPLETED].statusCode)){
//         return true;
//     }
//     return false;
// }

export const showShiftCancelBtn = (shiftStatusId) =>{ 
    if(shiftStatusId===Number(SHIFT_STATUS[ENUM_SHIFT_STATUS.CONFIRMED].statusCode) || shiftStatusId===Number(SHIFT_STATUS[ENUM_SHIFT_STATUS.ON_GOING].statusCode) ){
        return true;
    }
    return false;
}

export const showShiftScheduleBtn = (shiftStatusId) =>{ 
    if(shiftStatusId!==Number(SHIFT_STATUS[ENUM_SHIFT_STATUS.COMPLETED].statusCode)){
        return true;
    }
    return false;
}

export const showAddShiftBtn = (eventStatusId) =>{ 
    if(eventStatusId!==Number(EVENT_STATUS[ENUM_EVENT_STATUS.COMPLETED].statusCode) && 
        eventStatusId!==Number(EVENT_STATUS[ENUM_EVENT_STATUS.INVOICED].statusCode) && 
        eventStatusId!==Number(EVENT_STATUS[ENUM_EVENT_STATUS.CANCELLED].statusCode)){
        return true;
    }
    return false;
}

export const showShiftDuplicateBtn = (shiftStatusId) =>{ 
    if(shiftStatusId!==Number(SHIFT_STATUS[ENUM_SHIFT_STATUS.DECLINED].statusCode) && 
        shiftStatusId!==Number(SHIFT_STATUS[ENUM_SHIFT_STATUS.ON_GOING].statusCode) && 
        shiftStatusId!==Number(SHIFT_STATUS[ENUM_SHIFT_STATUS.COMPLETED].statusCode)   
    ){
        return true;
    }
    return false;
}

export const showCompleteEventBtn = (isClientPage, eventStatusId) =>{
    if(!isClientPage && (eventStatusId===Number(EVENT_STATUS[ENUM_EVENT_STATUS.CONFIRMED].statusCode) || eventStatusId===Number(EVENT_STATUS[ENUM_EVENT_STATUS.ON_GOING].statusCode))) {
        return true;
    }else{
        return false;  
    }

} 

export const showDiscountBtn = (isClientPage, eventStatusId) =>{
    if(!isClientPage && eventStatusId!==Number(EVENT_STATUS[ENUM_EVENT_STATUS.CANCELLED].statusCode)) {
        return true;
    }else{
        return false;  
    }

} 